import Axios from 'axios';
import { apiUrl } from './dataProvider';

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const addUploadCapabilities = (dataProvider) => ({
  ...dataProvider,
  update: (resource, params) => {
    switch (resource) {
      case 'users':
        if (!params.data.images) {
          return dataProvider.update(resource, params);
        } else {
          // The posts edition form uses a file upload widget for the pictures field.
          // Freshly dropped pictures are File objects
          // and must be converted to base64 strings
          const newPictures = params.data.images.filter(
            (p) => p.rawFile instanceof File
          );

          let formerPictures = params.data.images.filter(
            (p) => typeof p === 'string'
          );

          return Promise.all(newPictures.map(convertFileToBase64))
            .then((base64Pictures) =>
              Promise.all(base64Pictures.map(uploadImage))
            )
            .then((transformedNewPictures) => {
              return dataProvider.update(resource, {
                ...params,
                data: {
                  ...params.data,
                  images: [...formerPictures, ...transformedNewPictures],
                },
              });
            });
        }
      case 'ads':
        if (!params.data.image || typeof params.data.image === 'string') {
          return dataProvider.update(resource, params);
        } else {
          return convertFileToBase64(params.data.image)
            .then((base64Picture) => uploadImage(base64Picture))
            .then((transformedNewPicture) => {
              return dataProvider.update(resource, {
                ...params,
                data: {
                  ...params.data,
                  image: transformedNewPicture,
                },
              });
            });
        }
      default:
        return dataProvider.update(resource, params);
    }
  },
  create: (resource, params) => {
    switch (resource) {
      case 'users':
        if (!params.data.images) {
          return dataProvider.create(resource, params);
        } else {
          // The posts edition form uses a file upload widget for the pictures field.
          // Freshly dropped pictures are File objects
          // and must be converted to base64 strings
          const newPictures = params.data.images.filter(
            (p) => p.rawFile instanceof File
          );

          let formerPictures = params.data.images.filter(
            (p) => typeof p === 'string'
          );

          return Promise.all(newPictures.map(convertFileToBase64))
            .then((base64Pictures) =>
              Promise.all(base64Pictures.map(uploadImage))
            )
            .then((transformedNewPictures) => {
              return dataProvider.create(resource, {
                ...params,
                data: {
                  ...params.data,
                  images: [...formerPictures, ...transformedNewPictures],
                },
              });
            });
        }
      case 'ads':
        if (!params.data.image || typeof params.data.image === 'string') {
          return dataProvider.create(resource, params);
        } else {
          return convertFileToBase64(params.data.image)
            .then((base64Picture) => uploadImage(base64Picture))
            .then((transformedNewPicture) => {
              return dataProvider.create(resource, {
                ...params,
                data: {
                  ...params.data,
                  image: transformedNewPicture,
                },
              });
            });
        }
      default:
        return dataProvider.create(resource, params);
    }
  },
});

/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

export const uploadImage = (imgBase64) => {
  return new Promise(async (resolve, reject) => {
    await Axios.post(
      `${apiUrl}/image`,
      {
        image: imgBase64,
        type: 'BASE64',
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('token'),
        },
      }
    )
      .then((res) => {
        console.log(res.data.url);
        resolve(res.data.url);
      })
      .catch((error) => {
        console.log(error);
        reject('false to upload');
      });
  });
};

export default addUploadCapabilities;
